import DangerSvg from "@/components/shared/svgs/danger-svg";
import {
  type WindowSecureSupport,
} from "../utils/window-secure";

interface ProtectedContentNoticeProps {
  reason: Exclude<WindowSecureSupport, "supported">;
}

const COPY: Record<
  ProtectedContentNoticeProps["reason"],
  { title: string; body: string; hint: string }
> = {
  outdated: {
    title: "نسخهٔ ایتای شما قدیمی است",
    body: "محتوای این دوره محافظت‌شده است و نمایش آن به نسخهٔ جدیدتر ایتا نیاز دارد.",
    hint: "لطفاً ایتا را به‌روزرسانی کنید و دوباره وارد دوره شوید.",
  },
  "unsupported-platform": {
    title: "این دوره فقط در اندروید قابل مشاهده است",
    body: "محتوای این دوره محافظت‌ شده است و فقط در اندروید قابل مشاهده است",
    hint: "لطفاً دوره را با ایتا روی گوشی اندرویدی خود باز کنید.",
  },
  unavailable: {
    title: "این دوره فقط در اندروید قابل مشاهده است",
    body: "محتوای این دوره محافظت‌ شده است و فقط در اندروید قابل مشاهده است",
    hint: "لطفاً دوره را با ایتا روی گوشی اندرویدی خود باز کنید.",
  },
};

export const ProtectedContentNotice = ({
  reason,
}: ProtectedContentNoticeProps) => {
  const copy = COPY[reason];

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 py-16 text-center">
      <DangerSvg />
      <h2 className="text-base font-bold text-foreground">{copy.title}</h2>
      <p className="max-w-sm text-sm leading-7 text-default-600">{copy.body}</p>
      <p className="max-w-sm text-sm leading-7 text-default-500">{copy.hint}</p>
    </div>
  );
};

export default ProtectedContentNotice;
